import React from 'react'
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer'
import TopNav from '../../../components/TopNav/TopNav'

const Terms = () => {
  return (
    <StyledBgContainer>
      <TopNav showArrow={true} />
      <h1 className="heading">Terms & Conditions</h1>
      <p>
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry.
      </p>
      <p>
        Lorem Ipsumis simply dummy text of the printing and typesetting
        industry. Lorem Ipsum has been the industry&apos;s standard dummy text
        ever since the 1500s, when an unknown printer took a galley of type and
        scrambled it to make a type specimen book. It has survived not only five
        centuries, but also the leap into electronic typesetting, remaining
        essentially unchanged. It was popularised in the 1960s with the release
        of Letraset sheets containing Lorem Ipsum passages, and more recently
        with desktop publishing software like Aldus PageMaker including versions
        of Lorem Ipsum. Why do we use it? . The point of using Lorem Ipsum is
        that it has a more-or-less normal distribution of letters, as opposed to
        using &apos;Content here, content here, making it look like readable
        English. Many desktop publishing packages and web page editors now use
        Lorem Ipsum as their default model text, and a search for lorem ipsum
        will uncover many web sites still in their infancy. Various versions
        have evolved over the years, sometimes by accident, sometimes on purpose
        (injected humour and the like). Why do we use it? It is a long
        established fact that a reader will be distracted by the readable
        content of a page when looking at its layout. Various versions have
        evolved over the years, sometimes by accident, sometimes on purpose
        (injected humour and the like).
      </p>
    </StyledBgContainer>
  )
}

export default Terms
